import { Descriptions, Form, Input, InputNumber, Radio, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import toast from "react-hot-toast";
import { save } from "../../features/save/saveSlice";
import BankTopUp from "./BankTopUp";

const { TextArea } = Input;
function Topup(setactive) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { saving } = useSelector((state) => state.save);
  const { walletObj } = useSelector((state) => state.obj);
console.log("walletObj",walletObj)
  const [value, setValue] = useState("STK");
  const onChange = (e) => {
    setValue(e.target.value);
  };

  const plainOptions = [
    { label: "STK", value: "STK" },
    { label: "Manual", value: "MANUAL" },
        { label: "Bank", value: "BANK" },
  ];

  const items = [
    {
      key: "1",
      label: "Paybill Number",
      children: <div>{walletObj?.collectionPaybill}</div>,
    },
    {
      key: "2",
      label: "Account Number",
      children: <div>{walletObj?.walCode}</div>,
    },
  ];

  const onFinish = async (data) => {
    data.walCode = walletObj?.walCode;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/stk/push",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await navigate("/my-wallet");
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handlePrevious = async () => {
    await navigate("/my-wallet");
  };

  return (
    <div className="flex flex-col">
      <div className="lg:w-[40%] w-full">
        <Radio.Group onChange={onChange} value={value} options={plainOptions} />

        {value === "STK" ? (
          <>
            {" "}
            <div className="text-[#0E0E0E] text-[1rem] font-[400] mt-[1rem]">
              Option 1: Pay via Phone Number
            </div>
            <div className="mt-[.5rem] text-[#424242] font-[400] text-[.75rem]">
              Enter your Safaricom number and we'll send a prompt notification
              to complete the payment via M-Pesa.
            </div>
            <Form
              layout="vertical"
              ref={formRef}
              name="control-ref"
              onFinish={onFinish}
              className="mt-[.5rem]"
              style={{
                maxWidth: "100%",
              }}
              form={form}
              // initialValues={prodd}
            >
              <Form.Item
                className="table-form-item"
                name="mobileNo"
                label="Phone Number"
                rules={[
                  {
                    required: true,
                    message: "Please add Phpne Number",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.length === 12) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Phone number must be exactly 10 characters")
                      );
                    },
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  countryCodeEditable={false}
                  className="input"
                />
              </Form.Item>

              <Form.Item
                name="amount"
                label="Amount"
                rules={[
                  {
                    required: true,
                    message: "Enter amount",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Enter amount"
                  className="input flex"
                />
              </Form.Item>

              <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
                <div className="justify-start"></div>
                <div className="justify-end flex items-center gap-x-2">
                  <div className="w-[150px]">
                    <button
                      key="back"
                      type="button"
                      onClick={handlePrevious}
                      className="cstm-btn"
                    >
                      Previous
                    </button>
                  </div>

                  <div className="w-[150px]">
                    <button
                      key="submit"
                      type="submit"
                      className="cstm-btn-2"
                      disabled={saving}
                    >
                      {saving ? <Spin /> : " Pay Now"}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </>
        ) : value === "MANUAL" ?(
          <>
            {" "}
            <div className="text-[#0E0E0E] mt-[1rem] text-[1rem] font-[400]">
              Option 2: Pay via Paybill
            </div>
            <div className="mt-[1rem] rounded-[.25rem] border border-dashed border-[#C8D3E0] p-[1rem]">
              <Descriptions column={1} colon={true} items={items} />
            </div>
            <div className="flex  justify-center mt-[56px] mb-[48px]">
              <div className="justify-end flex items-center gap-x-2">
                <div className="w-[150px]">
                  <button
                    key="back"
                    type="button"
                    onClick={handlePrevious}
                    className="cstm-btn"
                  >
                    Previous
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : value === "BANK" ? (
            <BankTopUp/>
        ):null}
      </div>
    </div>
  );
}

export default Topup;
